module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.16.0.0.box.377.589.943.119.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.16.0.0.box.377.589.943.119.q.90"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.1.0.box.100.1353.1509.589.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.16.1.0.box.100.1353.1508.481.q.60"
    }
  }, [_vm._v("I "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("gratefully ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("acknowledge ")]), _vm._v("the help I received in collecting information for this book from Colonel Francis E. Thomas at the Jackson Barracks Military Museum, Ron (\"Mr. Football\") Gaspar, sportswriter Pete Finney, baseball historian Arthur Schott, former AAU Boxing Champion Chester Banta, musicians Joe Arrigo and Rupert Surcouf, former television director Paul Yacich, television commentator Mel Leavitt, former baseball player Wilfred Theard, photographer James Lemoine of Louisiana Power and Light, the Historic New Orleans Collection archivists, all the veterans whose stories I told in chapter 7, and all the helpful librarians in the Louisiana Division of the Public Library. I am in your debt.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.1.box.103.1843.1506.99.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.0.0"
    }
  }), _vm._v("Also many thanks to f"), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.0.0"
    }
  }), _vm._v("riends and acquaintan"), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.9.0.0"
    }
  }), _vm._v("ces who loaned me tre"), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.14.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.15.0.0"
    }
  }), _vm._v("asured pictures, whic"), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.16.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.17.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _vm._v("h others may now enjoy.")]), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 17",
      "src": "data/content-0011.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.5"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 18",
      "src": "data/content-0012.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.6"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.7"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 19",
      "src": "data/content-0013.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.8"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0.9"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-937dfef8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0014.vue
// module id = 63
// module chunks = 0